import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCoupon } from "../../api/apiCoupons";
import { toast } from "react-hot-toast";

export const useDeleteCoupon = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteCouponMutate, isPending: isDeleting } = useMutation({
        mutationFn: deleteCoupon,
        onSuccess: (res) => {
            toast.success(res.message || "Coupon deleted successfully");
            queryClient.invalidateQueries(["coupons"]);
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Error deleting coupon");
        },
    });

    return { deleteCouponMutate, isDeleting };
};
